export default {
  methods: {
    getPlaceTypeIcon(type) {
      const icons = {
        [this.$const('room_types',"ND")]: 'alert-octagon',
        [this.$const('room_types',"AGRITOURISM")]: 'barley',
        [this.$const('room_types',"APARTMENTS")]: 'home',
        [this.$const('room_types',"BB")]: 'account-supervisor-circle',
        [this.$const('room_types',"BOUTIQUE")]: 'bow-tie',
        [this.$const('room_types',"BUDGET")]: 'cash',
        [this.$const('room_types',"CAMPING")]: 'caravan',
        [this.$const('room_types',"CASTLE")]: 'castle',
        [this.$const('room_types',"CHALET")]: 'bee-flower',
        [this.$const('room_types',"FAMILY")]: 'home-heart',
        [this.$const('room_types',"HOTEL")]: 'office-building',
        [this.$const('room_types',"PREMIUM")]: 'sparkles',
        [this.$const('room_types',"RELAIS")]: 'spa',
        [this.$const('room_types',"VILLAS")]: 'home-modern',
        [this.$const('room_types',"RESIDENCE")]: 'home-group',
        [this.$const('room_types',"GLAMPING")]: 'tent',
        [this.$const('room_types',"OTHER")]: 'more',
      };

      return !!icons[type] ? icons[type] : 'home';
    },
    getPlaceTypeColor(type) {
      const color = {
        [this.$const('room_types',"ND")]: '#E0E0E0',
        [this.$const('room_types',"AGRITOURISM")]: '#D4E157',
        [this.$const('room_types',"APARTMENTS")]: '#81D4FA',
        [this.$const('room_types',"BB")]: '#80CBC4',
        [this.$const('room_types',"BOUTIQUE")]: '#FFE082',
        [this.$const('room_types',"BUDGET")]: '#FFCCBC',
        [this.$const('room_types',"CAMPING")]: '#BBDEFB',
        [this.$const('room_types',"CASTLE")]: '#A1887F',
        [this.$const('room_types',"CHALET")]: '#8D6E63',
        [this.$const('room_types',"FAMILY")]: '#E57373',
        [this.$const('room_types',"HOTEL")]: '#FFF176',
        [this.$const('room_types',"PREMIUM")]: '#FFFF00',
        [this.$const('room_types',"RELAIS")]: '#90A4AE',
        [this.$const('room_types',"VILLAS")]: '#9CCC65',
        [this.$const('room_types',"RESIDENCE")]: '#D4E157',
        [this.$const('room_types',"GLAMPING")]: '#BBDEFB',
        [this.$const('room_types',"OTHER")]: '#BDBDBD',
      };

      return !!color[type] ? color[type] : '#eeeeee';
    },
  },
}
